import { type Kmat, type LinearSubstep } from "~/Configurators/Linear/models";
import { isTileStandard } from "~/Configurators/common/tileUtils";
import { type SubstepType } from "~/Configurators/Linear/dtos";
import type { LinearConfiguratorState } from "~/Configurators/Linear/redux/types";
import type { WithTranslation } from "react-i18next";

export interface SummaryData {
  name: string;
  value: string;
  isStandard?: boolean;
  extra?: string;
}

export class SummaryDataProvider {
  public kmats: Dict<Kmat[]>;
  public substeps: Dict<LinearSubstep>;

  constructor(
    private state: LinearConfiguratorState,
    public t: WithTranslation["t"],
  ) {
    this.kmats = state.kmats;
    this.substeps = state.substeps;
  }

  getConfiguratorType() {
    return this.state.type;
  }

  getStepName(index: number) {
    return this.t(this.state.steps[index - 1].name);
  }

  getGaStepName(index: number): string {
    return `${index} - ${this.getStepName(index)}`;
  }

  prepareTileSubstepSummary(
    stepType: SubstepType,
    postProcessor?: TileSubstepSummaryPostProcessor,
  ): SummaryData | null {
    const step = this.state.substeps[stepType];

    if (!step || step.selectedTile === null) {
      return null;
    }
    const allTiles = [...step.tiles];
    step.groupedTiles?.forEach((group) => allTiles.push(...group.tiles));
    const selectedTile = allTiles[step.selectedTile];
    const summary: SummaryData = {
      name: this.t(step.name),
      value: this.t(selectedTile.name),
      isStandard: isTileStandard(selectedTile, this.kmats),
    };
    postProcessor?.(summary, step, this.kmats);
    return summary;
  }
}

type TileSubstepSummaryPostProcessor = (data: SummaryData, step: LinearSubstep, kmats: Dict<Kmat[]>) => void;
